import { combineReducers } from 'redux';

import { headerTitleReducer } from './headerTitle';
import { leftMenuReducer } from './leftMenu';

import { licenseReducer } from './license';
import { sessionOverReducer } from './sessionOver';
import { sidebarReducer } from './sidebar';
import { modalsReducer } from './modals';
import { collapsibleModalsReducer } from './collapsibleModals';
import { saveBackUrlReducer } from './saveBackUrlReducer';
import { calendarReducer } from './calendar';
import { notificationReducer } from './notification';
import { colorSchemeReducer } from './colorScheme';

import {
    approvalPersonListFiltersReducer,
    approvalProjectListFiltersReducer,
    worksheetListFiltersReducer,
    projectListFiltersReducer,
    requestListFiltersReducer,
    projectMassListFiltersReducer,
    worksheetMassListFiltersReducer,
    notdoneListFiltersReducer,
} from './table/filters';

import {
    approvalPersonListSortReducer,
    approvalProjectListSortReducer,
    projectListSortReducer,
    worksheetListSortReducer,
    requestListSortReducer,
    notDoneSortReducer,
    projectMassListSortReducer,
    worksheetMassListSortReducer
} from './table/sort';

import {
    approvalPersonListSelectedReducer,
    approvalProjectListSelectedReducer,
    requestListSelectedReducer,
    worksheetListSelectedReducer,
    worksheetMassListSelectedReducer,
    notdoneListSelectedReducer,
    worksheetMassListSelectedStageKeyReducer,
} from './table/selected';

import {
    projectListPaginationReducer,
    worksheetListPaginationReducer,
    requestListPaginationReducer,
    approvalPersonListReducer,
    approvalProjectListReducer,
    projectMassListPaginationReducer,
    worksheetMassListPaginationReducer,
    notDoneListPaginationReducer,
} from './table/pagination';

export default {
    sidebar: sidebarReducer,
    modals: modalsReducer,
    collapsibleModals: collapsibleModalsReducer,
    license: licenseReducer,
    sessionOver: sessionOverReducer,
    backUrl: saveBackUrlReducer,
    table: combineReducers({
        request: combineReducers({
            filters: requestListFiltersReducer,
            sort: requestListSortReducer,
            selected: requestListSelectedReducer,
            pagination: requestListPaginationReducer,
        }),
        approvalPerson: combineReducers({
            filters: approvalPersonListFiltersReducer,
            sort: approvalPersonListSortReducer,
            selected: approvalPersonListSelectedReducer,
            pagination: approvalPersonListReducer,
        }),
        approvalProject: combineReducers({
            filters: approvalProjectListFiltersReducer,
            sort: approvalProjectListSortReducer,
            selected: approvalProjectListSelectedReducer,
            pagination: approvalProjectListReducer,
        }),
        project: combineReducers({
            sort: projectListSortReducer,
            filters: projectListFiltersReducer,
            pagination: projectListPaginationReducer,
        }),
        worksheet: combineReducers({
            selected: worksheetListSelectedReducer,
            sort: worksheetListSortReducer,
            filters: worksheetListFiltersReducer,
            pagination: worksheetListPaginationReducer,
        }),
        notdone: combineReducers({
            selected: notdoneListSelectedReducer,
            sort: notDoneSortReducer,
            pagination: notDoneListPaginationReducer,
            filters: notdoneListFiltersReducer,
        }),
        projectMass: combineReducers({
            sort: projectMassListSortReducer,
            filters: projectMassListFiltersReducer,
            pagination: projectMassListPaginationReducer,
        }),
        worksheetMass: combineReducers({
            sort: worksheetMassListSortReducer,
            pagination: worksheetMassListPaginationReducer,
            filters: worksheetMassListFiltersReducer,
            selected: worksheetMassListSelectedReducer,
            stage: worksheetMassListSelectedStageKeyReducer,
        })
    }),
    headerTitle: headerTitleReducer,
    leftMenu: leftMenuReducer,
    colorScheme: colorSchemeReducer,
    calendar: calendarReducer,
    notification: notificationReducer,
};
